module.exports = __webpack_public_path__ + "static/media/tl.6b6303b5.svg";